import React from 'react';
import { useFormik } from 'formik';
import { useQuery } from 'react-fetching-library';
import { Box, Modal, Card, CardContent, CardHeader, Button, TextField, Portal, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachmentIcon from '@mui/icons-material/Attachment';

import RichTextEditor from '../../../../notification/RichTextEditor';

import { getNotificationSettingsDetail } from '../../../../../../services/request';

import { useDropzone } from 'react-dropzone';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function SendMessagePreviewModalWithFiles({ handleSend, handleClose, type, fileNames = {}, additionalAction = () => undefined }) {
  const { loading, payload, error } = useQuery(getNotificationSettingsDetail(type));
  const [showRichText, setShowRichText] = React.useState(false);
  const [newFiles, setNewFiles] = React.useState([]);
  const onDrop = React.useCallback(files => setNewFiles(prev => [...prev, ...files]), [newFiles]);

  const { getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    noDrag: true,
    multiple: true,
    onDrop
  });


  const formik = useFormik({
    initialValues: {
      subject: '',
      message: '',
      files: []
    },
    validateOnChange: false,
    onSubmit: values => {
      const formData = new FormData();

      formData.append('subject', values.subject);
      formData.append('message', values.message);
      formData.append('files', JSON.stringify(values.files));
      newFiles.forEach(file => formData.append('newFiles', file));

      handleSubmit(formData);
    }
  });

  React.useEffect(() => {
    if (!error && !loading) {
      formik.setValues({ 'subject': payload.subject, 'message': payload.message, 'files': Object.keys(fileNames) });
      setShowRichText(true);
    }
  }, [loading]);

  const handleSubmit = values => {
    if (formik.values.subject.trim().length !== 0 && formik.values.message.trim().length !== 0) {
      handleSend(values);
    }
  };

  const handleDelete = value => {
    formik.setFieldValue('files', formik.values.files.filter(file => file !== value));
  };

  const handleDeleteNewFile = index => {
    setNewFiles(prev => prev.toSpliced(index, 1));
  };

  const handeSend = () => {
    formik.handleSubmit();
    additionalAction();
  };

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card style={{ ...style, width: 600 }}>
          <CardHeader
            title="Wyślij wiadomość"
            sx={{ textAlign: 'center' }}
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <TextField
              id="subject"
              fullWidth
              label="temat"
              value={formik.values.subject}
              onChange={formik.handleChange}
            />
            <Box height={20} />
            {showRichText ? <RichTextEditor
              text={formik.values.message}
              formik={formik}
              fieldName="message"
              label={null}
              placeholder="treść"
            /> : null}
            {/* <TextField
              id="message"
              multiline
              rows={8}
              fullWidth
              label="treść"
              value={formik.values.message}
              onChange={formik.handleChange}
            /> */}
            {Object.entries(fileNames).filter(file => formik.values.files.includes(file[0]))
              .map((file, index) => (
                <React.Fragment key={index}>
                  <Box height={20}/>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <AttachmentIcon color="primary"/>
                    <Typography variant="subtitle2">{file[1]}</Typography>
                    <IconButton aria-label="delete" style={{ marginLeft: '12px' }} onClick={() => handleDelete(file[0])}>
                      <DeleteIcon />
                    </IconButton>
                  </Stack>
                </React.Fragment>
              ))}
            {newFiles.map((file, index) => (
              <React.Fragment key={index}>
                <Box height={20}/>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <AttachmentIcon color="primary"/>
                  <Typography variant="subtitle2">{file.name}</Typography>
                  <IconButton aria-label="delete" style={{ marginLeft: '12px' }} onClick={() => handleDeleteNewFile(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Stack>
              </React.Fragment>
            ))}
            <Box height={20} />
            <div>
              <input {...getInputProps()} />
              <Button onClick={open} type="button" variant="outlined">
                <AttachmentIcon color="primary" style={{ marginRight: '4px' }}/>
                <span>Dodaj plik</span>
              </Button>
            </div>
            <Box height={20} />
            <Button variant="contained" fullWidth onClick={handeSend} disabled={formik.values.subject.trim().length === 0 || formik.values.message.trim().length === 0}>Wyślij</Button>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
